module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogged) ? _c('div', {
    staticClass: "app app-aside-fixed ",
    class: {
      's-menu': _vm.showMenu, 's-header': _vm.showHeader, 'app-aside-folded': _vm.menuFolded, 'app-header-fixed': _vm.showHeader
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.showHeader) ? _c('app-header', {
    on: {
      "toggleChat": _vm.toggleChat,
      "updateNotReadedMessagesChat": _vm.updateNotReadedMessagesChat
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('app-menu') : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.showFooter) ? _c('app-footer') : _vm._e()], 1) : _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14048482","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = 1509
// module chunks = 17